const UK = {
	"key": "value2",

	/*			CHART-MAKER			*/
	"DATA_VIEW": "Data view",
	"OBS_KPI": "KPI",
	"OBS_LOCAL_KPI": "KPI",
	"OBS_LOCAL_MONTH_KPI": "KPI",
	"OBS_SHARE": "Shared observations",
	"SHARE_OBS": "Share observation",
	"SHARE_COMMENT": "Do you have a comment for the observation:",
	"LAST_RA_OBS_TABLE": "Latest data table",
	"LAST_RA_TABLE": "Latest RA table",
	"POINTS_LINE": "Points",
	"OBS_TYPES": "Observations",
	"RA_COMMENTS": "Comments",

	"MONTHS": ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	"OBS_LAST_YEAR": "Observations last year",
	"SINCE_WEEK": "since last week",

	"CLOSE"					: "Close",
	"UNKOWN_ADDRESS": "Unkown address",
	"SHOW_EXT_OBS": "Show external observations",

	"AMOUNT_IN_DEP": "Obs. in department",
	"DEPARTMENT_INFO": "Department information",

	/*		DASHBOARD		*/
	"TOTAL_USERS"		: "Total users",
	"INFO"				: "Info",
	"MAP"				: "Map",
	"LAST_ACTIVE": "Last active",
	"LEAST_ACTIVE": "Least active",
	"TOTAL_POINTS_O": "Total point",
	"POINTS_PR_REP": "Point pr. rep",
	"COMMENTS_AMOUNT": "Comments amount",
	"ANSW_CHANGES_AMOUNT": "Answer changed",
	"OBS_AMOUNT": "Observations amount",
	"SHEET": "Sheet",
	"NEVER": "Never",
	"NO_DATA": "No data found",
	"QR_LOGIN": "QR login",


	"REMOVE_OBS_MSG": "Are you sure you want to remove observation #",
	"REMOVE_USR_MSG": "Are you sure you want to remove user #",
	"REMOVE_RA_MSG": "Are you sure you want to remove RA #",
	"REPORTS"				: "Reports",
	"REPORT"				: "Report",
	"TOTAL_OBS"			: "Total observations",

	"OBS_OWN_USR"		: "Obs. by your users",
	"OBS_OTH_USR"		: "Obs. by other users",
	"OBS_PR_USR"		: "Obs. per user",
	"OBS_WARN"			: "Unproccessed obs.",
	"TOTAL_RA"			: "Total reports",
	"POINT_PR_USR"		: "Points per user",
	"POINT_PR_RA"		: "Points per report",
	"COMMENT_PR_USR"	: "Comments per user",
	"TARGET_MONTH"		: "Target pr. month",
	"GENEREL_VIEW"		: "General overview",
	"RA_OBS"			: "Reports and observations",
	"GENEREL_STATIS"	: "General statistics",
	"RA_NO_POINTS"		: "Reports without points",
	"RA_20_POINTS"		: "Reports with more than 20 points",
	"OBS_LOW_PRIO"		: "Observations with low priority",
	"OBS_HIGH_PRIO"		: "Observations with high priority",
	"TOTAL_POINTS"		: "Total points per",
	"TOP_POINT_ADDR"	: "Adresses with the most points",
	"LOCATION"			: "Location",
	"LATEST_RA"			: "Latest answers",
	"LATEST_COMMENTS"	: "Latest comments",
	"LATEST_USERS"		: "Latest users",
	"TOP_5"				: "Top 5",
	"SET"				: "Set",
	"QUESTIONS"			: "Questions",
	"SINCE_LAST_WEEK"	: "since last week",
	"LANGUAGE": "Language",
	
	"RA_TABLE_EXTRAS" 	: ["Current", "Period", "RA quantity", "RA per. weekday"],

	/*			RA-PAGE			*/
	"ANSWERS"			: "Answers",
	"BASIC_STAT_POINTS"	: "Point statistics",
	"TIME"				: "Time",
	"TIME2"				: "Time",
	"EXPORT"			: "Export",
	"EXPORT_EXC"		: "Export to Excel",
	"ANALASYS"			: "Analyze",
	"GENEREL_INFO"		: "General information",
	"QUESTION"			: "Question",

	/*			OBS-PAGE		*/
	"HEAND"				: "Incident",
	"KONS"				: "Consequence",
	"IMAGE_AMOUNT"		: "Number of photos",
	"STATISTIC"			: "Statistics",
	"OBS_LATEST_30"		: "Observations the last 30 days",
	"OBSERVATION"		: "Observation",
	"OBSERVATIONS"		: "Observations",
	"NOTES"				: "Notes",
	"IMAGES"			: "Photos",
	"IMAGE"				: "Photo",
	"PRIORITY"			: "Priority",
	"TEMP_CHANGES"		: "Temporary solution to the problem",
	"STATUS"			: "Status",
	"STATUS_ARR"		: ["Action required", "Action started", "Action has been taken", "In other department"],//["Awaiting action", "Action initiated", "Has been fixed"],
	"HISTORY"			: "History",
	"ACTION"			: "Action",
	"ASSIGN_TO"			: "Assign to",
	"ASSIGNED_TO"		: "Assigned to",
	"CREATED_TEXT"		: "Created the observation",
	"YOU_ASSIGNED_OBS"	: "You have been assigned to a observation",
	"ASSIGNED_TO_USR"	: "Assigned to user",
	"UPDATED_STATUS"	: "Updated status",
	"ADDED_COMMMENT"	: "Added comment",
	"RESPONSIBLE"		: "Responsible",

	/*			USERS-PAGE		*/
	"EDIT_USER"			: "Edit user",
	"EDIT_DEPARTMENT"	: "Edit department",
	"UPDATE"			: "Edit",
	"REPEAT"			: "Repeat",
	"PASS"				: "Password",
	"EDIT"				: "Edit",
	"CREATE_USER"		: "Create user",
	"CREATE_DEPARTMENT"	: "Create department",
	"CREATE"			: "Create",
	"EDIT"				: "Edit",
	"DEPARTMENTS"		: "Departments",
	"DEPARTMENT"		: "Department",
	"DEPARTMENT_TO"		: "Department to",
	"DEP_SHOW_HIDE"		: "Show/hide subdepartments",
	"RA_WARN"			: "Send RA SMS reminder",

	/*			MENU 			*/
	"Moduler"			: "Modules",
	"VIEW"				: "Overview",
	"Risk assesment"				: "Risk assessment",
	"Observationer"				: "Observations",
	"Brugere"				: "Users",
	"Oversigt"				: "Dashboard",
	"Notifikationer"				: "Notifications",
	"Indbakke"				: "Inbox",
	"Superuser"				: "Superuser",

	

	"CURRENT"				: "Current",
	"OTHER_CONTACT"				: "Other contact",

	/*		ERRORS 				*/

	"DEPART_UPDATED"	: "The department has been updated!",
	"DEPART_ALREADY"	: "The department already exists!",
	"DEPART_CREATED"	: "The department has been created!",
	"DEPART_NOT_FOUND"	: "The department does not exist!",

	"USER_NOT_FOUND"	: "User not found!",
	"USER_UPDATED"		: "User updated",
	"USER_ALREADY"		: "User already exists!",
	"USER_CREATED"		: "User created",
	"RA_NOT_FOUND"		: "Report not found!",
	"OBS_NOT_FOUND"		: "Observation not found!",
	"PASS_NOT_UPDATED"	: "The specified password has not been updated, as they not the same.",

	
	"CHANGES_SAVED"		: "Your changes has been added!",


	"PASS_NOT_ALIKE": "The passwords is not identical",
	"MAILS_NOT_ALIKE": "The mails is not identical",
	"USER_RANK_MISSING": "The ranks has to be specified",
	"DEPARTMENT_MISSING": "The department has to be specified",

	/*		Notifications 		*/
	"NOT_TITLE"		: "Notifications",
	"NEW_NOT"			: "New notification",
	"EDIT_NOT"		: "Edit notification",
	"2_DAYS"			: "2 days",
	"TIME_SINCE_RA" : "Days since last RA",
	"SAVE"				: "Save",
	"TYPE"				: "Type",
	"OBS_TYPE"				: "Observation type",
	"EQUALS"				: "Equals",
	"SEND"				: "Send",
	"TO"				: "To",
	"NOTE"				: "Note",
	"NOTE_PLACE"	: "Ex: Message for Anders.",
	"TEST"				: "Test",
	"REMOVE"				: "Remove",
	"REMOVE_MSG"				: "Are you sure you want to delete this?",
	"NOT_TYPES": {
		"NEW_REPORT": "New report",
		"NEW_OBS": "New observation",
		"NEW_OBS_TYPE": "New observation type",
		"NO_RAS": "Risk assessment reminder",
		"REPORT": "Collection report",
	},
	"INTERVAL": "Interval",
	"NOT_SEND_TYPES": ["Mail", "SMS"],


	/*		Users 		*/
	"PHONE"				: "Phone",
	"REPEAT_MAIL"	: "Repeat mail",
	"REPEAT_MAIL_NAME"	: "Repeat mail / username",
	"REPEAT_PASS"	: "Repeat password",
	"RANK"				: "Rank",
	"RANKS"				: ["Normal user", "Administrator"],
	"RA_SHEETS"		: "R.A sheets",
	"UPDATE_USER"	: "Update user",
	"ADD_USER"		: "Add user",

	/*		GENEREL TABLES 		*/
	"ADDRESS"			: "Address",
	"RISC"				: "Risk",
	"CREATED_BY"		: "Created by",
	"CREATEDBY"			: "Created by",
	"LASTACTIVE"		: "Last active",
	"DATE"				: "Date",
	"MAIL"				: "Mail",
	"MAIL_NAME"			: "Mail / username",
	"NAME"				: "Name",
	"FIRST_NAME"		: "Firstname",
	"LAST_NAME"			: "Lastname",
	"COMMENT"			: "Comment",
	"SHOW"				: "Show",
	"SHOW_REPORT"		: "Show report",
	"SHOW_OBS"			: "Show observation",
	"DELETE_OBS"		: "Remove observation",
	"EXTERNAL_REP"		: "External report",
	"ID"				: "#",
	"TITLE"				: "Titel",
	"STARTED_DATE"		: "Start date",
	"DONE"				: "Done",
	"BY"				: "By",
	"NOTES_AMOUNT"		: "Number of notes",
	"REP_AMOUNT"		: "Reports amount",
	"PUBLIC_RA"			: "Public report",
	"TITLE"				: "Titel",
	"TITLE"				: "Titel",
	"ANSWER"			: "Answer",
	"SAND"				: "Probability",
	"KONS"				: "Consequence",
	"CORRECT?"			: "Correct?",
	"ANSWER_CHANGED"	: "Answer changed",
	"ANSWER"			: "Answer",
	"START_TIME"		: "Start time",
	"END_TIME"			: "Time of completion",
	"LAST_RA" : "Latest report",
	"LAST_OBS" : "Latest observation",
	"CUSTOMER"			: "Customer",
	"SIGN_OUT"			: "Sign out",
	"ANSWER"			: "Answer",
	"ANON"			: "Anonymous",
	"NOT_DONE"		: "Not finished",
	"YES/NO"			: {
	                  "1" : "Yes",
	                  "2" : "No"
                  },

	
	/*		LINKS 			*/
	"VIEW_LINKS": {
		"obs": "/reports/%CAT_ID%/%ID%",
		"ra": "/reports/%CAT_ID%/%ID%",
		"users": "/users/edit/%ID%",
	},
	/*		API 			*/
	"WRONG_LOGIN"		: "Wrong login information, try again",
	"NOT_LOGGED"		: "You are not logged in.",
	"RA_SAVED"			: "The report has been saved, and a copy has been sent to your mailbox.",
	"RA_SAVED_NO_M"	: "The report has been saved.",
	"RA_SAVED_FOLLOW"	: "The report has been saved, remember to fill out the follow-up report when you are done.",
	"OBS_SAVED"			: "The follow-up report has been saved.",
	"ERROR_CODE"		: "A error occurred. Error-code:",
	"OBS_SAVED_MAIL"	: "Your observation has been saved, and a copy has been sent to your mailbox.",
	"OBS_SAVED_NO_MAIL"	: "Your observation has been saved.",
	"AT"				: "at",
	"POINT"				: "point",
	"MAIL_SENT"			: "A mail has been sent to the specified mail address.",
	"ERROR_RETRY"		: "A error occurred, try again!",

	"MAIL_NEW_TYPE"		: "There has just been created a new",
	"MAIL_TYPE"			: "by",
	"MAIL_FOUND_LINK"	: "It can be found at the following link",

	/*	CHART-MAKER */
	"RA_POINTS_PIE": "RA point",
	"POINTS_LINE": "RA points",
	"LAST_RA_TABLE": "Latest RA",
	"RA_COMMENTS": "Most used words",

	"DATA_OPTIONS": {
		retrieve: true,
		"iDisplayLength": 50,
		"order": [[ 0, "desc" ]],
		"language": {
			"lengthMenu": "Show _MENU_ pr page",
			"zeroRecords": "Nothing found",
			"info": "Page _PAGE_ / _PAGES_",
			"infoEmpty": "No content",
			"search":         "Search: ",
			 "paginate": {
				"first":      "First",
				"last":       "Last",
				"next":       "Next",
				"previous":   "Previous"
			},
			"infoFiltered": "(filtewring from _MAX_ columns)"
		}
	},
};
export default UK;


// WEBPACK FOOTER //
// ./src/components/langs/phpUK.js